import { render, staticRenderFns } from "./DurationBlock.vue?vue&type=template&id=651fa81d&"
import script from "./DurationBlock.vue?vue&type=script&lang=js&"
export * from "./DurationBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports